import gql from 'fraql'

const configQueries = {
  getConfigRecord: gql`query configRec($param: String!) {
      allConfigs (condition:{param: $param}, last: 1) {
        nodes {
          param,
          value
        }
      }
  }`,
  configsBatchGet: gql`query ConfigsBatchGet($paramNames: [String!]!) {
    configsBatchGet(paramNames: $paramNames) {
      nodes {
        param
        value
      }
    }
  }`
}

export default configQueries



// WEBPACK FOOTER //
// ./src/graphql/config.js